// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store';

import header from './components/header.vue';
import nav from './components/nav.vue';
import carousel from './components/carousel.vue';
import product from './components/product.vue';
import about from './components/about.vue';
import contact from './components/company_contact.vue';
import page_footer from './components/page_footer.vue';
import main from './components/main.vue';
import systemScheme from './components/system-scheme-content.vue';
import system from './components/system.vue';
import writePlan from './components/writePlan.vue';
import UE from './components/UE.vue';
import showPlan from './components/showPlan.vue';
import $ from 'jquery';


import newnav from './components/nwenav.vue';
Vue.component('v-menu', newnav);

// 引入富文本框架
import '../static/UE/ueditor.config.js'
import '../static/UE/ueditor.all.min.js'
import '../static/UE/lang/zh-cn/zh-cn.js'
import '../static/UE/ueditor.parse.min.js'



Vue.component('v-header', header); /** 头部组件，公司的logo */
Vue.component('v-nav', nav); /** 导航栏组件 */
Vue.component('v-carousel', carousel); /** 首页轮播组件 */
Vue.component('v-product', product); /** 产品中心滚动组件 */
Vue.component('v-about', about); /** 关于我们页面 */
Vue.component('v-company-contact', contact); /** 联系我们页面组件 */
Vue.component('v-footer', page_footer); /** 页尾 */
Vue.component('v-main', main); /** 首页内容 */
Vue.component('system-scheme', systemScheme); /**系统方案 */
Vue.component('system-show', system); /** 首页系统方案展示 */
Vue.component('write-plan', writePlan); /** 写文章 */
Vue.component('show-plan', showPlan);
Vue.component('UE', UE); /** 富文本 */
/** 用于横幅的组件  */
Vue.component('page-banner', {
  props: ['title', 'content'],
  template: '<div class="banner"><h1 style="font-size:48px;">{{title}}</h1><p style="font-size:20px;margin-top:10px;">{{content}}</p></div>'
});

/** 面包屑组件注册 */
import breadcrumb from './components/breadcrumb/src/breadcrumb.vue';
import breadcrumb_item from './components/breadcrumb/src/breadcrumb-item.vue';
Vue.component('v-breadcrumb', breadcrumb);
Vue.component('v-breadcrumb-item', breadcrumb_item);

/** 分页组件 */
import pager from './components/pagination/src/pager.vue';
Vue.component('v-pagination', pager);



Vue.config.productionTip = false

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);



/** 此处主要用于拦截后台管理url地址 */
router.beforeEach((to, from, next) => {
  if (to.meta.requireAuth) {
    var token = store.state.token;
    /** 需要添加 */
    /** 如果有jwt令牌需要在发送给后台，验证是否为正确的jwt ... */

    if (token) {
      next();
    } else {
      next({
        path: "/login"
      });
    };
  } else {
    next();
  }
});




Vue.prototype.$ajax = function (url, type, data, success) {
  $.ajax({
    url: url,
    type: type,
    data: data,
    success: function (data, textStatus, jqXHR) {
      if (success) {
        success(data, textStatus, jqXHR)
      }
    }
  });
}
/** 提交接送数据版 */
Vue.prototype.ajax = function (url, type, data, success, error) {
  $.ajax({
    url: url,
    type: type,
    data: data,
    headers: {
      'Content-Type': 'application/json',
    },
    success: function (data, textStatus, jqXHR) {
      if (success) {
        success(data, textStatus, jqXHR)
      }
    },
    error(jqXHR, status, errormsg) {
      if (error) {
        error(jqXHR, status, errormsg);
      };
    },
  });
}

new Vue({
  el: '#app',
  router,
  store,
  components: {
    App
  },
  template: '<App/>',
})



// WEBPACK FOOTER //
// ./src/main.js